import {
  batchDeleteDetail,
  commitExcel,
  deleteCheck,
  deleteDistribute,
  disassembleDetail,
  distributeList,
  distributeListForOperate,
  exportBatchDistributeCheckResult,
  getBatchDistributeCheckResult, // 提交excel,
  getCommitRes,
  getDistributeBaseInfo,
  getTemplate,
  queryDetail,
  queryDistributePage,
  queryError,
  queryPayment,
  queryPayRes,
  saveDistribute,
  saveSingleDetail,
  submit,
  updateBank,
} from '../services';

export default {
  namespace: 'batchDistribute',
  state: {},
  effects: {
    *commitExcel({ payload }, { call }) {
      return yield call(commitExcel, payload);
    },
    *distributeList({ payload }, { call }) {
      return yield call(distributeList, payload);
    },
    *distributeListForOperate({ payload }, { call }) {
      return yield call(distributeListForOperate, payload);
    },
    *getCommitRes({ payload }, { call }) {
      return yield call(getCommitRes, payload);
    },
    *getDistributeBaseInfo({ payload }, { call }) {
      return yield call(getDistributeBaseInfo, payload);
    },
    *deleteDistribute({ payload }, { call }) {
      return yield call(deleteDistribute, payload);
    },
    *queryPayment({ payload }, { call }) {
      return yield call(queryPayment, payload);
    },
    *queryDistributePage({ payload }, { call }) {
      return yield call(queryDistributePage, payload);
    },
    *saveDistribute({ payload }, { call }) {
      return yield call(saveDistribute, payload);
    },
    *batchDeleteDetail({ payload }, { call }) {
      return yield call(batchDeleteDetail, payload);
    },
    *queryDetail({ payload }, { call }) {
      return yield call(queryDetail, payload);
    },
    *queryError({ payload }, { call }) {
      return yield call(queryError, payload);
    },
    *submit({ payload }, { call }) {
      return yield call(submit, payload);
    },
    *updateBank({ payload }, { call }) {
      return yield call(updateBank, payload);
    },
    *saveSingleDetail({ payload }, { call }) {
      return yield call(saveSingleDetail, payload);
    },
    *queryPayRes({ payload }, { call }) {
      return yield call(queryPayRes, payload);
    },
    *getTemplate({ payload }, { call }) {
      return yield call(getTemplate, payload);
    },
    *deleteCheck({ payload }, { call }) {
      return yield call(deleteCheck, payload);
    },
    *disassembleDetail({ payload }, { call }) {
      return yield call(disassembleDetail, payload);
    },
    *exportBatchDistributeCheckResult({ payload }, { call }) {
      const result = yield call(exportBatchDistributeCheckResult, payload);
      return result;
    },

    *getBatchDistributeCheckResult({ payload }, { call }) {
      const result = yield call(getBatchDistributeCheckResult, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
